import React from 'react';


import { ReactComponent as DownloadIcon } from "../../../../../../../assets/img/svg/downloadIcon.svg";
import { exportToExcel } from 'views/pages/manage/unAssigned/collectPayment/selectCharges/downloadChargesData/downloadExcel/exportToExcel';
import { getBulkUploadDetailsByPid } from './utils';

const headers = [
    { label: 'PSID', key: 'psid' },
    { label: 'Application Id', key: 'applicationId' },
    { label: 'Payment Method', key: 'paymentMode' },
    { label: 'Process Id', key: 'processInstanceId' },
    { label: 'DO ID', key: 'doId' },
    { label: 'Business Area', key: 'businessArea' },
    { label: 'Status', key: 'status' },
    { label: 'Acknowledgement ID', key: 'ackId' },
    { label: 'Reason', key: 'response' },


]


const DownloadExcel = ({
    pid,
    fileName,
    status
}) => {
    const downloadHandler = async () => {
        try {
            const res = await getBulkUploadDetailsByPid(pid)
            console.log('res', res)
            const resp = res.map((item) => {
                if (item?.status == 'SUCCESS') {
                    return { ...item, ackId: item?.response, response: null }
                }
                else {
                    return { ...item, ackId: null, response: item?.response }
                }
            })
            exportToExcel(resp, headers, fileName)
        }
        catch (err) {
            console.log(err)
        }
    }



    return (
        <div>
            {status !== 'PROCESSING' && <DownloadIcon className=' ml-2 cursor' onClick={() => { downloadHandler() }} />}
        </div>
    );

}

export default DownloadExcel;